import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { useCalculationsStore } from '../store/calculations';

import { useCurrentCalculatorSegments } from '../composables/useCurrentCalculatorSegments';

export function useCurrentCalculation() {
  const calculationStore = useCalculationsStore();

  const { getSegmentById } = useCurrentCalculatorSegments();

  const route = useRoute();

  const currentCalculation = computed(() => {
    return calculationStore.getCalculationByUuid(String(route.params.calculationId));
  });

  const currentCalculationSegment = computed(() => {
    return (
      currentCalculation.value?.calculation_segments.find(
        (segment) => segment.segment_id === Number(route.params.segmentId)
      ) || null
    );
  });

  const calculationRequiredSegments = computed(() => {
    const segments = currentCalculation.value?.calculation_segments;

    return segments?.filter((segment) => !getSegmentById(segment.segment_id)?.is_required) || [];
  });

  function getItemById(itemId: number) {
    const currentSegmentItems = currentCalculation.value?.calculation_segments.flatMap(
      (segment) => segment.calculation_segment_items
    );

    if (!currentSegmentItems) {
      return null;
    }

    return currentSegmentItems.find((item) => item.item_id === itemId) || null;
  }

  function getItemValue(itemId: number) {
    const currentItem = getItemById(itemId);

    if (currentItem?.type === 'product') {
      return currentItem.product_id;
    }

    if (currentItem?.type === 'value') {
      return currentItem.value;
    }

    if (currentItem?.type === 'rule') {
      return currentItem.rule_id;
    }

    return null;
  }

  function getProductItemById(itemId: number) {
    const currentItem = getItemById(itemId);

    if (currentItem?.type === 'product') {
      return currentItem;
    }

    return null;
  }

  function getValueItemById(itemId: number) {
    const currentItem = getItemById(itemId);

    if (currentItem?.type === 'value') {
      return currentItem;
    }

    return null;
  }

  function getRuleItemById(itemId: number) {
    const currentItem = getItemById(itemId);

    if (currentItem?.type === 'rule') {
      return currentItem;
    }

    return null;
  }

  function getCurrentCalculationSegmentById(segmentId: number) {
    return (
      currentCalculation.value?.calculation_segments.find(
        (segment) => segment.segment_id === segmentId
      ) || null
    );
  }

  function isSegmentAddedInCurrentCalculation(segmentId: number) {
    const segment = getCurrentCalculationSegmentById(segmentId);

    return segment !== null;
  }

  return {
    currentCalculation,
    currentCalculationSegment,
    calculationRequiredSegments,
    getItemValue,
    getItemById,
    getProductItemById,
    getValueItemById,
    getRuleItemById,
    getCurrentCalculationSegmentById,
    isSegmentAddedInCurrentCalculation,
  };
}
